<nav *ngIf="viewModel$ | async as viewModel">

    <div class="logo-container">
        <a class="logo-link" routerLink="">
            <span class="logo-img"></span>
        </a>
    </div>

    <div class="breadcrumbs">
            <span *ngFor="let link of (breadcrumb$ | async); let first = first">
                <span *ngIf="!first">/ </span>
                <a *ngIf="link.active" (click)="navigate(link.element)">{{link.name}} </a>
                <a *ngIf="!link.active" class="disabled">{{link.name}} </a>
            </span>
    </div>

    <div class="menu">
        <button mat-icon-button [matMenuTriggerFor]="menuAccount" matTooltip="Mon compte">
            <mat-icon>person</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menuReferentiel" matTooltip="Gestion du référentiel"
                *ngIf="viewModel.isSuperadmin || viewModel.isAdminParc">
            <mat-icon>view_list</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menuAdmin" matTooltip="Administration"
                *ngIf="viewModel.isSuperadmin || viewModel.isDeveloper">
            <mat-icon>settings</mat-icon>
        </button>

        <mat-menu #menuAccount="matMenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <button mat-menu-item *ngIf="viewModel.currentUser != null" routerLink="profile" routerLinkActive="active">
                <mat-icon>account_box</mat-icon>
                <span>Profil</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.currentUser != null" (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Déconnexion</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.currentUser == null" (click)="login()">
                <mat-icon>login</mat-icon>
                <span>S'authentifier</span>
            </button>
        </mat-menu>

        <mat-menu #menuReferentiel="matMenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <ng-container *ngIf="viewModel.isSuperadmin">
                <button mat-menu-item routerLink="referentiel/groupe-parametre" routerLinkActive="active">
                    <mat-icon>category</mat-icon>
                    <span>Groupes de paramètres</span>
                </button>
                <button mat-menu-item routerLink="referentiel/parametre-espaces" routerLinkActive="active">
                    <mat-icon>crop_free</mat-icon>
                    <span>Paramètres des espaces</span>
                </button>
                <button mat-menu-item routerLink="referentiel/type-lot" routerLinkActive="active">
                    <mat-icon>grid_view</mat-icon>
                    <span>Types de zones</span>
                </button>
                <button mat-menu-item routerLink="referentiel/type-piece" routerLinkActive="active">
                    <mat-icon>crop_square</mat-icon>
                    <span>Types de pieces</span>
                </button>
                <button mat-menu-item routerLink="referentiel/type-ouvrage" routerLinkActive="active">
                    <mat-icon>list_alt</mat-icon>
                    <span>Types d'ouvrages et paramètres</span>
                </button>
                <button mat-menu-item routerLink="referentiel/type-document" routerLinkActive="active">
                    <mat-icon>description</mat-icon>
                    <span>Types de documents</span>
                </button>
            </ng-container>
            <ng-container *ngIf="viewModel.isAdminParc && viewModel.isSuperadmin">
                <mat-divider class="my-2"></mat-divider>
            </ng-container>
            <ng-container *ngIf="viewModel.isAdminParc">
                <button mat-menu-item routerLink="referentiel/parc/{{viewModel.idParc}}" routerLinkActive="active">
                    <mat-icon>verified_user</mat-icon>
                    <span>Gérer le référentiel du parc</span>
                </button>
            </ng-container>
        </mat-menu>

        <mat-menu #menuAdmin="matMenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <button mat-menu-item *ngIf="viewModel.isSuperadmin" routerLink="admin/users" routerLinkActive="active">
                <mat-icon>manage_accounts</mat-icon>
                <span>Gestion des utilisateurs</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.isSuperadmin" routerLink="admin/audits" routerLinkActive="active">
                <mat-icon>notification_important</mat-icon>
                <span>Audits</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.isSuperadmin" routerLink="admin/logs" routerLinkActive="active">
                <mat-icon>sticky_note_2</mat-icon>
                <span>Logs</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.isSuperadmin || viewModel.isDeveloper" routerLink="admin/docs" routerLinkActive="active">
                <mat-icon>menu_book</mat-icon>
                <span>Documentation API</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.isSuperadmin" (click)="forceDataRefresh()">
                <mat-icon>sync</mat-icon>
                <span>Forcer le rafraîchissement des données serveur</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.isSuperadmin" (click)="exportReferentiel()">
                <mat-icon>file_download</mat-icon>
                <span>Exporter le référentiel</span>
            </button>
            <button mat-menu-item *ngIf="viewModel.isSuperadmin" routerLink="referentiel/import-full-referentiel">
                <mat-icon>file_upload</mat-icon>
                <span>Importer le référentiel (nouvel environnement)</span>
            </button>
        </mat-menu>
    </div>

</nav>
